import { apiPyAxios } from "../api/axios";

const unwrap = (res) => res.data?.results ?? res.data ?? [];

export const getGalleries = async ({ langId }, signal) => {
  const res = await apiPyAxios.get("galleries/", {
    params: { lang: langId, page_size: 500 },
    signal,
  });

  const galleries = unwrap(res);

  return galleries
    .sort((a, b) => (a.priority || 0) - (b.priority || 0))
    .map((gallery) => ({
      ...gallery,
      images: (gallery.images || []).sort(
        (x, y) => (x.priority || 0) - (y.priority || 0)
      ),
    }));
};
